import React from "react";
import { Dropdown } from "antd";
import type { MenuProps } from "antd";
import classNames from "classnames";
import ImageWithFallback from "../../../../ImageWithFallback";
import styles from "./style.module.scss";
import { CardItem } from "../index";

interface ImageItemProps {
  item: CardItem;
  index: number;
  classId: string;
  onImageClick?: (items: CardItem[], selectedIndex: number) => void;
  onItemDelete?: (classId: string, mediaId: string) => void;
  items: CardItem[];
}

export default function ImageItem({
  item,
  index,
  classId,
  onImageClick,
  onItemDelete,
  items,
}: ImageItemProps) {
  const handleImageClick = (e: React.MouseEvent) => {
    if (onImageClick && items) {
      onImageClick(items, index);
    }
  };

  const menuItems: MenuProps["items"] = onItemDelete
    ? [
        {
          key: "delete",
          label: "Delete",
          onClick: async (e) => {
            console.log("e", e);
            try {
              await onItemDelete(classId, item.id);
            } finally {
            }
          },
        },
      ]
    : [];

  const imageContent = (
    <div
      className={classNames(styles.imageWrapper, {})}
      onClick={handleImageClick}
      data-testid="image-wrapper"
    >
      <ImageWithFallback
        plainImage={{ src: item.imgUri }}
        thumbImage={{ src: item.imgUri }}
        alt={`preview-${index}`}
        className={styles.img}
      />
    </div>
  );

  return (
    <Dropdown
      menu={{ items: menuItems }}
      trigger={["contextMenu"]}
      placement="bottomLeft"
    >
      {imageContent}
    </Dropdown>
  );
}
